<template>
  <div style="height:100%">

    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.46">
      <template #table1>
        <TableMain name="one table" ref="saleOrderDispatchSearchTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" @on_query="on_query" @tool_invoke="tool_invoke"
          @current_changed="current_changed" @only_methods="only_methods" :hb_table_class="'hb_table_sods_class1'"
          :only_text="$t('common.only_so_uncomplated')" :isBusy="isBusy_table1" :table_height_adjust="-8"
          :loading_width="30">
          <template #query>
            <el-input :placeholder="$t('common.sales_order_num')" size="small" style="width: 200px" clearable
              v-model="SalesId"></el-input>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <BaseContainer style="height:100%" class="one_table">
          <TableMain name="two table" :fields="fields2" :show_query_container="false"
            ref="saleOrderDispatchSearchTable2" :title="table_title.title2" :table_height_adjust="8"
            :isBusy="isBusy_table2" :loading_width="25" :hb_table_class="'hb_table_sods_class2'" :show_email="true"
            @email_invoke="SendEmail" @state_change="excuteStateChange"
            :show_toolbar_button="[0, 0, 1, 1, 1, 0, 0, 1, 1]" @on_input="on_input" @on_change="on_change"
            @on_cell_button_click="on_cell_button_click">
            <template #toolbar="">
              <el-tooltip content="更新供应商报价" placement="top" effect="light">
                <el-button type="info" plain style="width: 55px" class="ml-2" @click="RefreshVendPrice(true)"><i
                    class="icon iconfont icon-refresh"></i></el-button>
              </el-tooltip>
              <el-checkbox class="ml-2" v-model="only_ax_exception" @change="exception_changed">{{
                $t("common.only_exception") }}</el-checkbox>
            </template>
            <template #operation>
              <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
                @on_query="Table2_SaveData" :label="$t('common.save')" class="ml-2"></QueryButton>
            </template>
          </TableMain>
        </BaseContainer>
      </template>
    </SplitContainer2>
    <!-- 附件 -->
    <el-dialog title="附件管理" :visible.sync="accessoryVisible" width="60%" :top="'5vh'" :close-on-click-modal="false"
      @opened="dialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'SalesDispatch'" @setAccessory="setAccessory"></FileUpload>
    </el-dialog>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import numbro from 'numbro'
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as PurchaseOrderController from "../../controllers/mm/PurchaseOrderController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as VendPurchaseQuoteOutController from "../../controllers/sd/VendPurchaseQuoteOutController"
import * as saleOrderDispatchAddController from "../../controllers/sd/saleOrderDispatchAddController"
import * as SaleOrderDispatchSearchController from "../../controllers/sd/saleOrderDispatchSearchController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as notify_template from "../../shared/notify_template"
import FileUpload from "../FileUpload.vue"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer2 from "../components/container/SplitContainer2"
import TableMain from "../components/table/TableMain"

export default {
  name: "saleOrderDispatchSearch",
  components: {
    BaseContainer,
    TableMain,
    TestQueryPanel,
    SplitContainer2,
    QueryButton,
    FileUpload
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sales_order_detail",
        title2: "table_dispatch_detail",
      },
      fields: SaleOrderDispatchSearchController.fields.default,
      fields2: SaleOrderDispatchSearchController.fields.dicpatch_fields,
      rules: SaleOrderDispatchSearchController.rules,
      isBusy_table1: false,
      isBusy_table2: false,
      SalesId: "",
      his_SOLine_data: [],
      his_dispatch_list: [],
      changed_list: [],
      all_role_users: [],
      his_group_price_list: null,
      invent_m: null,
      SOInfo: null,
      all_role_list: [],
      only_ax_exception: false,
      current_accessory: null, ///当前派单选中附件
      accessoryVisible: false
    }
  },
  async created() {
    await this.getAllRoles()
    await this.getAllRoleUsers()
    // let _field1 = _.find(this.fields2, {
    //   key: "TaxGroup",
    // });
    // _field1["_options"] = {
    //   base_on_field: "AccountNum",
    //   provider: (v) => {
    //     let _lt = _this.setTaxGroupData(v)
    //     return _.map(_lt, (t) => {
    //       return { value: t.TaxGroup, label: t.TaxGroupName }; //VariantName
    //     });
    //   },
    // };
  },
  computed: {
    userCust() {
      return this.$store.state.biz_data.userInfo.user_custs
    }
  },
  watch: {
    userCust(newV, oldV) {
      if (newV && window.location.href.indexOf("?k=") > -1) {
        // this.SalesId = window.location.href.split("?k=")[1]
        // this.on_query(this.$refs.saleOrderDispatchSearchTable1.SetData)
      }
    }
  },
  methods: {
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.filter(_dt, { is_sys: false, is_valid: true })

    },
    setTaxGroupData(dropdownSearchValue) {
      let _list = []
      let soItem = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()
      if (soItem) {
        let taxGroupList = _.filter(this.$store.state.biz_data.baseData.TaxGroupHeading, { dataAreaId: soItem.dataAreaId })
        let taxgroup_options = taxGroupList //_.uniqBy(this.$store.state.biz_data.baseData.TaxGroupHeading, "TaxGroup")
        if (taxgroup_options.length > 0) {
          _.each(taxgroup_options, (t) => {
            let _index = _.findIndex(_list, { TaxGroup: t.TaxGroup })
            if (_index < 0) {
              _list.push({
                TaxGroup: t.TaxGroup,
                TaxGroupName: t.TaxGroup + ":" + t.TaxGroupName
              })
            }
          })
        }
      }
      return _list
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      this.$refs.saleOrderDispatchSearchTable2.SetData([])
      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = {
        SalesId: this.SalesId,
      }
      if (!_.isNull(date_range) && this.SalesId == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
        // _params["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }
      let _result = await SaleOrderDispatchSearchController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = []
        _.each(_result[0], (t) => {
          let _index = _.findIndex(
            this.$store.state.biz_data.userInfo.user_custs,
            { AccountNum: t.CustAccount }
          )
          if (_index > -1) {
            _list.push(t)
          }
        })
        let dt = _.cloneDeep(
          _.orderBy(_list, ["SalesTable_id", "LineNum"], ["desc", "asc"])
        )
        this.his_SOLine_data = dt
        set_data(dt)
      }
      this.isBusy_table1 = false
    },
    only_methods(val) {
      console.log(val)
      if (val) {
        let _filter_data = _.filter(this.his_SOLine_data, function (t) {
          return t.valid_remain > 0
        })
        this.$refs.saleOrderDispatchSearchTable1.SetData(_filter_data)
      } else {
        this.$refs.saleOrderDispatchSearchTable1.SetData(this.his_SOLine_data)
      }
    },
    async getDispatchItems(data, isLoading = true) {
      if (isLoading)
        this.isBusy_table2 = true
      let _result = await SaleOrderDispatchSearchController.methods.getDispatchItemsSql({ SalesLineId: data.id })
      data.valid_approve = data.SalesQty
      data.valid_remain = data.SalesQty
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let rt = _.orderBy(_result[0], ["id"], ["desc"])
        _.each(rt, (t) => {
          commonController.methods.getUserNameFromRole(
            this.all_role_users,
            t,
            "fcGetDocumentApprover",
            "Approver"
          )
          commonController.methods.getUserNameFromRole(
            this.all_role_users,
            t,
            "fcGetDocumentApprover",
            "Up_Approver"
          )
          t.ApproveRemark = ""
          t.AccessoryCount = 0
          if (t.Accessory && t.Accessory != "")
            t.AccessoryCount = JSON.parse(t.Accessory).length
        })
        this.$refs.saleOrderDispatchSearchTable2.SetData(rt)

        let _list = _.cloneDeep(_result[0])
        if (_list.length > 0) {
          let _sum_va = 0
          let _sum_vr = 0
          _.each(_list, (t) => {
            if (t.is_deleted == false) {
              if (t.is_approved == false) {
                _sum_va += parseFloat(t.qty)
              }
              _sum_vr += parseFloat(t.qty)
            }
          })
          data.valid_approve = _sum_va
          data.valid_remain = data.SalesQty - _sum_vr
        }
        this.his_dispatch_list = _.cloneDeep(_result[0])
      }
      this.isBusy_table2 = false
    },
    ///获取订单相关信息
    async getOrderInfo(current) {
      let _result = await SalesOrderController.methods.getData({
        id: current.SalesTable_id,
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.SOInfo = _result[0][0]
      }
    },
    async current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.saleOrderDispatchSearchTable2.SetData([])
        return
      }

      this.changed_list = []
      ///获取订单相关信息
      await this.getOrderInfo(current)
      ///获取派单明细
      await this.getDispatchItems(current)
      ///获取物料相关信息
      await this.getInventData()
      ///获取物料价格
      let _itemIds = []
      _itemIds.push(current.ItemId)
      // await this.getItemPrice(_itemIds);
      console.log(this.invent_m)
    },
    async excuteStateChange(data, cb) {
      let warning_msg = ""
      if (data.selected_items.length == 0) {
        warning_msg = this.$t("notify.not_data")
      }
      if (this.changed_list.length > 0 && data.state != "deleted") {
        warning_msg = this.$t("notify.save_before_approve")
      }
      if (warning_msg != "") {
        this.msgToasts(warning_msg, "info")
        cb(false)
        return
      }
      let _line_current = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()
      if (data.state === "deleted") {
        await this.excuteDeleteAction(data, cb, _line_current)
      } else if (data.state === "approved" || data.state === "unapproved") {
        await this.excuteApproveAction(data, cb, _line_current)
      } else if (data.state === "refused") {
        await this.excuteRefuseAction(data, cb, _line_current)
      } else if (data.state === "exception_handling") {
        await this.exception_handle(data, cb, _line_current)
      }
    },
    ///删除
    async excuteDeleteAction(data, cb, _line_current) {
      if (!await this.msgModal(this.$t("notify.is_deleted"))) {
        cb(false)
        return
      }

      ///删除、审核前调用AX接口检查是否已出库
      let is_my_data = true //是否自己创建
      let is_approved = true//是否已审批
      let is_in_approve = false//是否在审批中
      _.each(_.cloneDeep(data.selected_items), (t) => {
        if (t.create_by && t.create_by != this.$store.state.biz_data.userInfo.user_id) {
          is_my_data = false
        }
        if (t.fcCheckDocumentAllApproved == true) {
          is_approved = false
        }
        if (t.isInApprove == true) {
          is_in_approve = true
        }
      })
      ///检查订单是否审核
      let _is_order_approved = await SaleOrderDispatchSearchController.methods.checkOrderIsApproved({ salesOrderId: _line_current.SalesTable_id })

      let warning_msg = ""
      if (!is_my_data) {
        warning_msg = this.$t("notify.not_created_by_yourself")
      }
      else if (!is_approved) {
        warning_msg = this.$t("notify.has_approved")
      }
      else if (is_in_approve) {
        warning_msg = this.$t("notify.in_approving_can_not_deleted")
      }
      else if (!_.isNull(_is_order_approved) && !_is_order_approved.state) {
        warning_msg = _is_order_approved.message
      }

      if (warning_msg != "") {
        this.msgToasts(warning_msg)
        cb(false)
        return
      }

      //调用AX接口
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.waiting"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      ///删除的集合
      let _list = _.cloneDeep(data.selected_items)
      let _update_soline_form = []

      if (_line_current) {
        _.each(_list, (m) => {
          m.qty = parseFloat(m.qty)
        })
        _update_soline_form.push({
          id: _line_current.id,
        })
      }
      // console.log(_update_soline_form);
      ///整理ax参数
      let _ax_list = _.filter(_list, function (t) {
        return !_.isEmpty(t.AXSalesId) && !_.isNull(t.AXSalesId)
      })
      let ax_params = this.getAXParams(_ax_list, "delete")
      let result = await SaleOrderDispatchSearchController.methods.deleteData(
        data.selected_items,
        _update_soline_form,
        ax_params,
        this
      )
      if (!_.isNull(result)) {
        if (result.state) {
          if (result.data && result.data.length > 0) {
            let _rdata = _.filter(result.data, { Code: "data/e/update_sl_validremain" })
            if (_rdata.length > 0 && _rdata[0].Result && _rdata[0].Result.Data.length > 0) {
              _line_current.valid_approve = _rdata[0].Result.Data[0][0].valid_approve
              _line_current.valid_remain = _rdata[0].Result.Data[0][0].valid_remain
            }
          }
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          ///删除邮件
          let notify_list = []
          _.each(data.selected_items, (t) => {
            ///普通审批邮件
            notify_list.push({
              idx: _.toString(t.id),
              notify_type: "sod_approve",
            })
          })
          if (notify_list.length > 0) {
            await commonController.methods.sendOrCancelNotify("cancel", notify_list)
          }

          this.$refs.saleOrderDispatchSearchTable2.RemoveItems(data.selected_items)
          cb(true)
        } else {
          this.msgToasts(result.message, "info")
          cb(false)
          let _exception_params = _.map(result.data, (t) => {
            return {
              isAXError: true,
              AXError: result.message,
              id: t.id
            }
          })
          await saleOrderDispatchAddController.methods.updateSODAxState(_exception_params)
          ///获取派单明细
          await this.getDispatchItems(this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem(), false)
        }
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }

      loading.close()
    },
    ///审核反审
    async excuteApproveAction(data, cb, _line_current) {
      let _state = data.state == "approved" ? true : false

      if (!await this.msgModal(this.$t("notify.is_continue"))) {
        cb(false)
        return
      }
      ///检查
      let res_check = await this.approvedCheckMethod(data.selected_items, _state)
      if (!res_check) {
        cb(false)
        return
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.waiting"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _selected_list = _.cloneDeep(data.selected_items)
      console.log(_selected_list)
      ///先执行平台审批
      let afterData = []
      let plant_action_ok = await this.excuteApprovePlant(_selected_list, _state)
      if (!plant_action_ok) return
      await this.getDispatchItems(_line_current)
      _.each(this.$refs.saleOrderDispatchSearchTable2.my_data, (t) => {
        let _ix = _.findIndex(_selected_list, { id: t.id })
        if (_ix > -1) {
          let cmt = _.cloneDeep(t)
          afterData.push(cmt)
        }
      })
      console.log(afterData)
      let res_msg = [], is_exception = false, _params = []
      let groupList = _.groupBy(afterData, "AccountNum")
      for (var i in groupList) {
        let res_approve = await this.excuteApprove(groupList[i], _state, data)
        if (res_approve != "") {
          res_msg.push("<hr/><div>" + this.$t("common.provider") + this.$t("common.num") + "：" + i + "，" + res_approve + "</div>")
          for (var v in groupList[i]) {
            _params.push({
              isAXError: true,
              AXError: res_approve,
              id: groupList[i][v].id
            })
          }
        }
      }
      if (res_msg.length == 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.ax_error") + "：" + _.join(res_msg, " "), "info", null, true)
        cb(false)
        is_exception = true
        if (_state && _params.length > 0) {
          await saleOrderDispatchAddController.methods.updateSODAxState(_params)
        }
      }

      if (_state) {
        //审批后发邮件给下一级，反审不需要
        await this.SendEmail({ data_sourse: afterData, code: "add", is_not_notify: true })
        if (!is_exception) {
          ///所有审批成功后发邮件通知派发创建人及供应商邮件通知人
          await this.sendEmailAfterApproved()
        }
      }

      loading.close()
    },
    ///拒批
    async excuteRefuseAction(data, cb, _line_current) {
      if (!await this.msgModal(this.$t("notify.is_continue"))) {
        cb(false)
        return
      }

      let warning_msg = ""
      ///检查是否有该权限
      let _check_list = await this.checkApproveStatus(true)
      if (_check_list.length > 0) {
        warning_msg = this.$t("notify.not_privileges") + "（" + _.join(_check_list, "，") + "）"
      }
      if (warning_msg != "") {
        this.msgToasts(warning_msg, "error")
        cb(false)
        return
      }
      let _list = _.map(data.selected_items, (t) => {
        let _approve_remark = t.ApproveRemark
        if (!t.ApproveRemark || t.ApproveRemark == "") {
          _approve_remark = "退回"
        }
        return {
          DocumentType: "SalesOrderDispatch",
          ItemId: t.id,
          Approver: t.Approver,
          ApproveRemark: _approve_remark
        }
      })
      console.log(_list)
      let rt = await SaleOrderDispatchSearchController.methods.refuseList(_list)
      console.log(rt)
      if (rt && rt.state) {
        let _p = {
          notify_type: "sod_approve_pass",
          subject: "sod_approve_pass",
          idx: "id"
        }
        //发邮件给系统设置退回邮件通知人
        let _profit_m = _.find(
          this.$store.state.biz_data.baseData.SystemSetting,
          { code: "email_notifier" }
        )
        if (_profit_m && _profit_m.setting_value != "") {
          let m = JSON.parse(_profit_m.setting_value)
          if (m.emailNotifier) {
            let email_setting_m = {}
            for (var k in m.emailNotifier) {
              email_setting_m[m.emailNotifier[k]] = data.selected_items
            }
            await this.exSendEmailAfterApproved(email_setting_m, _p, "vend", true)
          }
        }
        ///发邮件给创建人
        await this.exSendEmailAfterApproved(_.groupBy(data.selected_items, "create_by_username"), _p, "", true)
        //邮件通知人
        let list = []
        for (var i in data.selected_items) {
          let _m = _.cloneDeep(data.selected_items[i])
          let vend = _.find(this.$store.state.biz_data.baseData.Vender, {
            AccountNum: _m.AccountNum,
          })
          if (vend && vend.EmailNotifier && vend.EmailNotifier != "") {
            let _dt = _.split(vend.EmailNotifier, ",")
            if (_dt && _dt.length > 0) {
              _.each(_dt, (n) => {
                _m.create_by_username = n
                list.push(_.cloneDeep(_m))
              })
            }
          }
        }
        if (list.length > 0) {
          let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
          await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p, "vend", true)
        }
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        await this.getDispatchItems(_line_current)
      }
    },
    ///检查审批数据
    async approvedCheckMethod(_list, _state) {
      let res_check = true

      ///检查订单是否审核(因为有可能此时销售订单已经被反审)
      let _valid_m = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()
      let _is_order_approved = await SaleOrderDispatchSearchController.methods.checkOrderIsApproved({ salesOrderId: _valid_m.SalesTable_id })
      if (res_check && !_.isNull(_is_order_approved) && !_is_order_approved.state) {
        this.msgToasts(_is_order_approved.message, "info")
        res_check = false
      }

      ///检查是否已经审批或反审
      if (res_check && this.checkIsApproved(_list, "fcCheckDocumentAllApproved", _state)) {
        this.msgToasts(this.$t("notify.has_approved_or_unapproved"))
        res_check = false
      }
      ///检查是否有该权限
      let _check_list = await this.checkApproveStatus(_state)
      if (res_check && _check_list.length > 0) {
        this.msgToasts(this.$t("notify.not_privileges") + "（" + _.join(_check_list, "，") + "）", "error")
        res_check = false
      }
      if (_state) {
        ///再次查询派单AX状态
        let _approved_list = []
        let _check_ax_data_list = await SaleOrderDispatchSearchController.methods.getDispatchItems({ id: { in: _.map(_list, "id") } })
        if (!_.isNull(_check_ax_data_list) && _check_ax_data_list && _check_ax_data_list.length > 0) {
          _.each(_list, (t) => {
            let _m = _.find(_check_ax_data_list[0], { id: t.id })
            if (_m) {
              t.AXSalesId = _m.AXSalesId
              if (_m.fcCheckDocumentAllApproved == true) {
                _approved_list.push(_m.AccountNum)
              }
            }
          })
        }
        if (res_check && _approved_list.length > 0) {
          this.msgToasts(this.$t("common.provider_num") + "：" + _.join(_approved_list, "，") + "，" + this.$t("notify.must_selected_approved"), "info")
          res_check = false
        }
      }

      ///检查派发供应商是否包含物料
      let vi_check_list = []
      _.each(_list, (t) => {
        if (t._error && !_.includes(vi_check_list, t.AccountNum)) {
          vi_check_list.push(t.AccountNum)
        }
      })
      if (res_check && vi_check_list.length > 0) {
        res_check = await this.msgModal(this.$t("common.provider") + "：" + _.join(vi_check_list, "，") + this.$t("notify.not_dispatch_invent") + "，" + this.$t("notify.is_continue"))
      }
      return res_check

    },
    ///执行平台审核
    async excuteApprovePlant(_list, _state) {
      let _update_status_list = []
      let _roles = []
      let userPR = this.$store.state.biz_data.userInfo.user_roles_privileges.roles
      if (userPR) {
        _roles = _.map(userPR, "code")
      }
      for (var i in _list) {
        _list[i].is_approved = _state
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesOrderDispatch",
          ApproveType: "",
          ItemId: _list[i].id,
        })
        _.each(_as_result[0], (at) => {
          if (at) {
            if (_state) {
              if (_.includes(_roles, at.Approver) || this.$global.global_data.local_username == at.Approver) {
                at.is_approved = true
                at.username = this.$global.global_data.local_username
                at.order_dispatch_id = _list[i].id
                at.userId = this.$store.state.biz_data.userInfo.user_id
                at.ApproveRemark = _list[i].ApproveRemark //审批备注
                if (!_list[i].ApproveRemark || _list[i].ApproveRemark == "") {
                  at.ApproveRemark = "同意"
                }
                at.price = _list[i].price
                at.price_vend = _list[i].price_vend
                at.Sales_Order_Price = _list[i].Sales_Order_Price
                at.Sales_Doc_Price = _list[i].Sales_Doc_Price
                _update_status_list.push(at)
              }
            }
            else {
              ///临时修改
              at.is_approved = false
              at.username = this.$global.global_data.local_username
              at.order_dispatch_id = _list[i].id
              at.userId = this.$store.state.biz_data.userInfo.user_id
              at.price = _list[i].price
              at.price_vend = _list[i].price_vend
              at.Sales_Order_Price = _list[i].Sales_Order_Price
              at.Sales_Doc_Price = _list[i].Sales_Doc_Price
              _update_status_list.push(at)
            }
          }
        })
      }
      ///修改待审批数量
      let _update_valid_m = null
      let _current_valid = 0
      let _valid_m = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()
      if (_valid_m) {
        _.each(_list, (t) => {
          t.qty = parseFloat(t.qty)
        })
        let _line_sum_qty = _.sumBy(_list, "qty") * (_state ? 1 : -1)
        if (_current_valid >= 0) {
          _current_valid = _valid_m.valid_approve - _line_sum_qty
          _update_valid_m = {
            id: _valid_m.id,
            valid_approve: _current_valid < 0 ? 0 : _current_valid,
          }
          ///负数派单不改变剩余派单数量和待审批数量
          if (parseFloat(_valid_m.SalesQty) < 0) {
            _update_valid_m.valid_approve = 0
          }
        }
      }

      ///1、执行平台审核
      let _params = {
        approve_data: _update_status_list,
        update_valid_data: _update_valid_m,
        state: _state,
      }

      let result = await SaleOrderDispatchSearchController.methods.approveDataNew(_params)
      if (!_.isNull(result)) {
        if (result.state) {
          if (result.data.length > 0) {
            ///修改明细信息到界面
            if (result.data && result.data.length > 0) {
              let _rdata = _.filter(result.data, { Code: "data/e/update_sl_validremain", })
              if (_rdata.length > 0 && _rdata[0].Result && _rdata[0].Result.Data.length > 0) {
                _valid_m.valid_approve = _rdata[0].Result.Data[0][0].valid_approve
              }
            }
          }
          return true
        }
        return true
      }
      return false
    },
    ///执行AX审批
    async excuteApprove(_list, _state, data) {
      ///整理ax参数
      let ax_params = this.getAXParams(_list, _state ? "approve" : "unapprove")
      ///整理采购单参数
      let purch_params = this.getCreatePurchaseParams(_list, data.state)

      let _params = {
        purch_data: purch_params,
        ax_data: ax_params,
        state: _state,
      }
      console.log(_params)
      let result = await SaleOrderDispatchSearchController.methods.approveDataNew(_params)
      if (!_.isNull(result)) {
        if (result.state)
          return ""
        return result.message
      }
      return ""
    },
    ///审批后发邮件
    async sendEmailAfterApproved() {
      let selected_list = this.$refs.saleOrderDispatchSearchTable2.GetSelectedItems()
      let data = _.filter(selected_list, { fcCheckDocumentAllApproved: true })
      if (data.length == 0) {
        return
      }
      let _p = {
        notify_type: "sod_approve_pass",
        subject: "sod_approve_pass",
        idx: "id"
      }

      ///发邮件给派发人
      await this.exSendEmailAfterApproved(_.groupBy(data, "create_by_username"), _p, "vend")
      ///发邮件给订单创建人
      await this.exSendEmailAfterApproved(_.groupBy(data, "sd_create_by_username"), _p)
      //供应商邮件通知人
      let list = []
      for (var i in data) {
        let _m = _.cloneDeep(data[i])
        let vend = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: _m.AccountNum,
        })
        if (vend && vend.EmailNotifier && vend.EmailNotifier != "") {
          let _dt = _.split(vend.EmailNotifier, ",")
          if (_dt && _dt.length > 0) {
            _.each(_dt, (n) => {
              _m.create_by_username = n
              list.push(_.cloneDeep(_m))
            })
          }
        }
      }
      if (list.length > 0) {
        let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
        await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p, "vend")
      }
    },
    async exSendEmailAfterApproved(_list, _p, type, is_refused) {
      let notify_list = []
      for (var d in _list) {
        let lang_code = notify_template.methods.getUserLangCode(this, d)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _email_params = {
          notify_type: _p.notify_type,
          subject: email_template[_p.subject],
          create_by_username: d,
          list: _list[d],
          idx: _p.idx
        }
        let _ep = notify_template.methods.getApprovedEmailTemplate(_email_params, this, type, is_refused)
        notify_list.push(_ep)
      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify(
          "add",
          notify_list
        )
      }
    },
    ///检查是否已经审批或者反审
    checkIsApproved(items, code, state) {
      let _index = _.findIndex(items, (t) => {
        if (state) {
          if (t[code] == true && t.Approver == this.$global.global_data.local_username) {
            return t
          }
        }
        else {
          if (t[code] == true && t.Up_Approver == this.$global.global_data.local_username) {
            return t
          }
        }
      })
      return _index > -1
    },
    //数据检验
    async validData() {
      let _line_current = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()
      ///检查订单是否审核
      let _is_order_approved = await SaleOrderDispatchSearchController.methods.checkOrderIsApproved({ salesOrderId: _line_current.SalesTable_id })
      if (!_.isNull(_is_order_approved) && !_is_order_approved.state) {
        this.msgToasts(_is_order_approved.message, "info")
        return false
      }

      ////======检查退货不能修改为正数,且价格不能修改
      let _is_check_return_ok = false
      let _is_can_update_price = true
      let _is_price_ok = true
      _.each(this.changed_list, (t) => {
        t.qty = parseFloat(t.qty)
        if (_line_current && _line_current.SalesQty < 0 && t.qty > 0) {
          _is_check_return_ok = true
        }
        let _m = _.find(this.his_dispatch_list, { id: t.id })
        if (_m && _line_current && _line_current.SalesQty < 0 && parseFloat(_m.price) != parseFloat(t.price)) {
          _is_can_update_price = false
        }
        ///只要不是自制，其他供应商都要检查实际价格是否为空
        let _self_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          DataArea: _line_current.dataAreaId,
        })
        if (_self_m && _self_m.VenderAccountNum == t.AccountNum) {
        }
        else {
          let _inside_m = _.findIndex(
            this.$store.state.biz_data.baseData.CompanyInfo,
            { VenderAccountNum: t.AccountNum }
          )
          if (_inside_m > -1) {
            //内部
            if (_.isString(t.price) && !t.isNullPurchPrice) {
              _is_price_ok = false
            }
          }
          else {
            //外部
            if (_.isString(t.price) && !t.isNullPurchPrice) {
              _is_price_ok = false
            }
          }
        }
      })
      if (_is_check_return_ok == true) {
        this.msgToasts(this.$t("notify.sales_return_pcs_must_less_0"), "info")
        return false
      }
      else if (!_is_can_update_price) {
        this.msgToasts(this.$t("notify.sales_return_can_not_be_edited"), "info")
        return false
      }
      else if (!_is_price_ok) {
        this.msgToasts(this.$t("notify.purch_price_must_gt_0"), "error")
        return false
      }
      return true
    },
    ///获取生成采购单params
    getCreatePurchaseParams(data, state) {
      let result = { main: [], items: [], update_list: [] }
      let _create_list = []
      let _update_list = []
      ///仅初次审核才创建采购单
      _.each(data, (t) => {
        if (_.isEmpty(t.AXSalesId) || _.isNull(t.AXSalesId)) {
          _create_list.push(t)
        } else {
          _update_list.push(t)
        }
      })
      if (_create_list.length > 0 && state == "approved") {
        if (!_.isNull(this.SOInfo) && this.SOInfo) {
          let _group_list = _.groupBy(_create_list, "AccountNum")
          let order_master_list = []
          let order_item_list = []
          for (var i in _group_list) {
            let masterForm = {
              id: "",
              PurchId: "",
              OrderAccount: _group_list[i][0].AccountNum, //供应商账户
              OrderAccountName: _group_list[i][0].SEI_Name, //供应商名称
              CurrencyCode: this.SOInfo.CurrencyCode,
              InclTax: this.SOInfo.InclTax,
              dataAreaId: this.SOInfo.dataAreaId, //公司
              AX_PurchId: "", //AX采购单编号
              AX_SalesOrderId: "", //AX销售单编号
            }
            order_master_list.push(masterForm)

            let _num = 1
            ///添加items
            for (var j in _group_list[i]) {
              let itemForm = {
                id: "",
                PurchaseOrderId: "",
                LineNumber: _num,
                ItemId: _group_list[i][j].ItemId,
                NameAlias: _group_list[i][j].NameAlias,
                PurchQty: _group_list[i][j].qty, //数量
                PurchPrice: _group_list[i][j].price,
                PurchUnit: _.isNull(this.invent_m)
                  ? ""
                  : this.invent_m.DW_InventUnitId,
                LineAmount: _group_list[i][j].qty * _group_list[i][j].price,
                // modifiedDateTime: "",
                // createdDateTime: "",
                dataAreaId: this.SOInfo.dataAreaId, //公司
                RetailVariantId: _group_list[i][j].RetailVariantId,
                VariantName: _group_list[i][j].VariantName,
                DeliveryDate: _group_list[i][j].delivery_date,
                OrderDispatch_id: _group_list[i][j].id, //派单id
                AX_Line_PurchId: "", //AX采购单行编号
                AX_Line_SalesOrderId: "", //AX销售单行编号
                OrderAccount: _group_list[i][0].AccountNum,
              }
              order_item_list.push(itemForm)
              _num += 1
            }
          }

          result.main = order_master_list
          result.items = order_item_list
        }
      }
      if (_update_list.length > 0) {
        _.each(_update_list, (t) => {
          if (state == "approved") {
            result.update_list.push({
              OrderDispatch_id: t.id,
              is_approved: 1,
              is_deleted: 0,
            })
          } else if (state == "unapproved") {
            result.update_list.push({
              OrderDispatch_id: t.id,
              is_approved: 0,
              is_deleted: 0,
            })
          } else if (state == "deleted") {
            result.update_list.push({
              OrderDispatch_id: t.id,
              is_approved: 0,
              is_deleted: 1,
            })
          }
        })
      }
      return result
    },
    ///创建采购单
    async createPurchaseOrder(data) {
      let _approve_list = []
      ///仅初次审核才创建采购单
      _.each(data, (t) => {
        if (_.isEmpty(t.AXSalesId) || _.isNull(t.AXSalesId)) {
          _approve_list.push(_m)
        }
      })
      if (_approve_list.length == 0) {
        return
      }

      if (!_.isNull(this.SOInfo) && this.SOInfo) {
        let order_master_list = []
        let order_item_list = []
        let _group_list = _.groupBy(_approve_list, "AccountNum")
        for (var i in _group_list) {
          let masterForm = {
            id: "",
            PurchId: "",
            OrderAccount: _group_list[i][0].AccountNum, //供应商账户
            OrderAccountName: _group_list[i][0].SEI_Name, //供应商名称
            CurrencyCode: this.SOInfo.CurrencyCode,
            InclTax: this.SOInfo.InclTax,
            dataAreaId: this.SOInfo.dataAreaId, //公司
            AX_PurchId: "", //AX采购单编号
            AX_SalesOrderId: "", //AX销售单编号
          }
          order_master_list.push(masterForm)
          let _num = 1
          ///添加items
          for (var j in _group_list[i]) {
            let itemForm = {
              id: "",
              PurchaseOrderId: "",
              LineNumber: _num,
              ItemId: _group_list[i][j].ItemId,
              NameAlias: _group_list[i][j].NameAlias,
              PurchQty: _group_list[i][j].qty, //数量
              PurchPrice: _group_list[i][j].price,
              PurchUnit: _.isNull(this.invent_m)
                ? ""
                : this.invent_m.DW_InventUnitId,
              LineAmount: _group_list[i][j].qty * _group_list[i][j].price,
              // modifiedDateTime: "",
              // createdDateTime: "",
              dataAreaId: this.SOInfo.dataAreaId, //公司
              RetailVariantId: _group_list[i][j].RetailVariantId,
              VariantName: _group_list[i][j].VariantName,
              DeliveryDate: _group_list[i][j].delivery_date,
              OrderDispatch_id: _group_list[i][j].id, //派单id
              AX_Line_PurchId: "", //AX采购单行编号
              AX_Line_SalesOrderId: "", //AX销售单行编号
              OrderAccount: _group_list[i][0].AccountNum,
            }
            order_item_list.push(itemForm)
            _num += 1
          }
        }
        let result = await PurchaseOrderController.methods.createData(
          order_master_list,
          order_item_list
        )
        if (result) {
          console.log("采购单生成成功！")
        }
      }
    },
    on_input(data) {
      if (data.field.key == "Capacity") {
        return
      }
      if (data.field.key == "price") {
        this.setDisDataStateAndInfo(
          "saleOrderDispatchSearchTable2",
          ["price", "Capacity", "delivery_date"],
          data.item
        )
      } else {
        // if (data.field.key == "qty") {
        //   data.item.price = 0;
        // }
        this.setDisDataStateAndInfo(
          "saleOrderDispatchSearchTable2",
          ["Capacity", "delivery_date"],
          data.item
        )
      }
    },
    async on_change(data) {
      if (data.field.key == "delivery_date") {
        this.setDisDataStateAndInfo(
          "saleOrderDispatchSearchTable2",
          ["price", "qty", "delivery_date"],
          data.item
        )
      } else if (data.field.key == "TaxGroup") {
        let current = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()
        let vender = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: data.item.AccountNum,
        })
        let _amount_m = {
          currency: data.item.CurrencyCode,
          amount: data.item.price,
          incTax: vender.InclTax == "是" ? 1 : 0,
          taxGroup: data.item.TaxGroup,
          dataAreaId: current.dataAreaId,
        }
        let _cnyAmount_m =
          await SalesOrderController.methods.getLocalAmountWOTaxData(
            _amount_m
          )
        if (!_.isNull(_cnyAmount_m) && _cnyAmount_m[0]) {
          data.item.price_tax = _cnyAmount_m[0][0].CNYAmount
          data.item.price_wotax = _cnyAmount_m[0][0].CNYAmountWOTax
        }
      }
      let _m = _.cloneDeep(data.item)
      let _index = _.findIndex(this.changed_list, { id: _m.id })
      if (_index < 0) {
        this.changed_list.push(_m)
      } else {
        _.remove(this.changed_list, { id: _m.id })
        this.changed_list.push(_m)
      }
    },
    ///保存修改
    async Table2_SaveData(cb) {
      let _soline_current = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()
      let action_data = this.$refs.saleOrderDispatchSearchTable2.GetSelectedItems()
      ///修改只包含待审批数据
      let msg = ""
      let is_my_data = true///判断是否是自己创建的数据
      let is_qty_ok = true//检查数量
      let is_all_approved = false
      let is_valid_remain_ok = true
      _.each(action_data, (t) => {
        if (t.create_by && t.create_by != this.$store.state.biz_data.userInfo.user_id) {
          is_my_data = false
        }
        else if (t.qty == 0 || t.qty == "" || _.isNull(t.qty)) {
          is_qty_ok = false
        }
        else if (t.fcCheckDocumentAllApproved) {
          is_all_approved = true
        }
        else if (t.qty > _soline_current.valid_remain) {
          is_valid_remain_ok = false
        }
      })

      if (action_data.length == 0) {
        msg = this.$t("notify.not_selected_data")
      }
      else if (!is_my_data) {
        msg = this.$t("notify.not_created_by_yourself")
      }
      else if (!is_qty_ok) {
        msg = this.$t("notify.not_pcs")
      }
      else if (is_all_approved) {
        msg = this.$t("notify.approved_can_not_edit")
      }
      else if (!is_valid_remain_ok)
        msg = this.$t("notify.pcs_not_more_valid_dispatched_pcs")

      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(true)
        return
      }

      ///保存只针对未审核
      // if (this.changed_list.length > 0) {
      let _this = this
      //数据检测
      let _is_check_ok = await this.validData()
      if (!_is_check_ok) {
        cb(false)
        return
      }
      if (!await this.msgModal(this.$t("notify.is_continue"))) {
        cb(false)
        return
      }
      let _list = []
      let data = _.cloneDeep(action_data)
      _.each(data, (t) => {
        let _m = _.cloneDeep(saleOrderDispatchAddController.dataForm)
        for (var i in _m) {
          _m[i] = t[i]
        }
        if (t.delivery_date && _.isDate(t.delivery_date)) {
          _m.delivery_date = _this.$date.format(
            new Date(t.delivery_date),
            "yyyy-MM-dd"
          )
        }
        ///对比获取变更的数据
        let _change_m = _.find(_this.his_dispatch_list, { id: t.id })
        _m.change_qty = parseFloat(t.qty) - parseFloat(_change_m.qty)
        _m.documentCreateByUsername = this.$global.global_data.local_username
        let vender_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { VenderAccountNum: _m.AccountNum })
        _m.is_internal = 0
        if (vender_m) {
          _m.is_internal = 1
        }
        _list.push(_m)
      })
      ///修改平台数据

      ///修改剩余派单数量及待审核数量
      let _update_soline_form_list = []

      if (_soline_current) {
        let _alist = _.cloneDeep(
          _.filter(this.$refs.saleOrderDispatchSearchTable2.my_data, (t) => {
            return t.is_deleted == false && t.is_approved == false
          })
        )
        _.each(_alist, (m) => {
          m.qty = parseFloat(m.qty)
          m.profit_value = _.round((parseFloat(_soline_current.SalesPrice) - parseFloat(m.price)), 6)
        })
        let sum_dispathch = _.sumBy(_alist, "qty")
        let _update_soline_form = {
          id: _soline_current.id,
          valid_approve: sum_dispathch,
          valid_remain:
            _soline_current.valid_remain -
            (sum_dispathch - _soline_current.valid_approve),
        }
        ///负数派单不改变剩余派单数量和待审批数量
        if (parseFloat(_soline_current.SalesQty) < 0) {
          _update_soline_form.valid_approve = 0
          _update_soline_form.valid_remain = 0
        }
        _update_soline_form_list.push(_update_soline_form)
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.saveing"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      console.log(_list)

      let _params = {
        save_data: _list,
        update_soline_form_list: _update_soline_form_list,
        ax_params: null,
      }
      let result = await SaleOrderDispatchSearchController.methods.updateDispatchPre(_params)
      if (!_.isNull(result)) {
        if (result.state) {
          if (result.data && result.data.length > 0) {
            let _rdata = _.filter(result.data, {
              Code: "data/e/update_sl_validremain",
            })
            //修改订单明细上的剩余派单数量
            if (_rdata.length > 0 && _rdata[0].Result && _rdata[0].Result.Data.length > 0) {
              _soline_current.valid_approve = _rdata[0].Result.Data[0][0].valid_approve
              _soline_current.valid_remain = _rdata[0].Result.Data[0][0].valid_remain
            }
          }
          this.changed_list = []
        }
      }
      await this.getDispatchItems(_soline_current)
      ///调用AX
      let ax_action_data = this.$refs.saleOrderDispatchSearchTable2.my_data
      _list.forEach((t) => {
        let m = _.find(ax_action_data, (o) => { return t.id == o.id })
        if (m)
          t.fcCheckDocumentAllApproved = m.fcCheckDocumentAllApproved
      })
      ///整理ax参数
      let _ax_params = this.getAXParams(_list, "update")
      let _params1 = {
        ax_params: _ax_params,
      }
      let result1 = await SaleOrderDispatchSearchController.methods.updateDispatch(_params1)
      if (!_.isNull(result1)) {
        if (result1.state) {
          this.msgToasts(this.$t("notify.action_successfully"), "success")
        } else {
          this.msgToasts(result1.message, "info")
          let _p = _.map(_list, (t) => {
            return {
              isAXError: true,
              AXError: result1.message,
              id: t.id
            }
          })
          if (_p.length > 0)
            await saleOrderDispatchAddController.methods.updateSODAxState(_p)
        }
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
      await this.getDispatchItems(_soline_current)
      cb(false)
      loading.close()
    },
    ///整理ax参数
    getAXParams(_list, type_code) {
      let _this = this
      ///整理jsonData
      let _jsonData = []
      let _DW_InventUnitId = ""
      if (this.invent_m && !_.isNull(this.invent_m)) {
        _DW_InventUnitId = this.invent_m.DW_InventUnitId
      }
      let _soline_current = _.cloneDeep(this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem())
      let _self_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
        DataArea: this.SOInfo.dataAreaId,
      })


      for (var i in _list) {
        let t = _list[i]
        if (type_code == "approve" && !t.fcCheckDocumentAllApproved) {
          continue
        }
        let _Status = "", _ApproveStatus = ""
        ///如果AX数据为空则不需要调用ax接口
        if ((type_code == "unapprove" || type_code == "delete" || type_code == "update") && (_.isNull(t.AXSalesId) || t.AXSalesId == "")) {
          continue
        }
        switch (type_code) {
          case "approve": _Status = "Update"; _ApproveStatus = "Approve"; break
          case "unapprove": _Status = "Update"; _ApproveStatus = "Draft"; break
          case "update": _Status = "Update"; _ApproveStatus = t.fcCheckDocumentAllApproved ? "Approve" : "Draft"; break
          case "delete": _Status = "Delete"; _ApproveStatus = "Draft"; break
          case "error": _Status = "Update"; _ApproveStatus = "Approve"; break
        }

        if ((type_code == "approve" || type_code == "error") && (_.isNull(t.AXSalesId) || t.AXSalesId == "")) {
          _Status = "Create"
        }

        let _AccountNum = t.AccountNum
        let _vendTaxGroup = t.VendTaxGroup ///供应商税组
        if (_vendTaxGroup == "") {
          let _vend = _.find(this.$store.state.biz_data.baseData.Vender, {
            AccountNum: t.AccountNum,
          })
          if (_vend) {
            _vendTaxGroup = _vend.TaxGroup
          }
        }

        if (_self_m && _self_m.VenderAccountNum == t.AccountNum) {
          _AccountNum = ""
        }

        if (t.delivery_date && _.isDate(t.delivery_date)) {
          t.delivery_date = _this.$date.format(t.delivery_date, "yyyy-MM-dd")
        }
        let _purch_code = _soline_current.CurrencyCode
        if (t.PurchCurrencyCode && !_.isNull(t.PurchCurrencyCode)) {
          _purch_code = t.PurchCurrencyCode
        }
        let _AXInventTransRet = ""
        let _AXPurchInventTransRet = ""
        if (parseFloat(_soline_current.SalesQty) < 0) {
          _AXInventTransRet = t.AXInventTransRet
          _AXPurchInventTransRet = t.AXInventTransRet
        }

        _jsonData.push({
          SalesId: _soline_current.id,
          CustAccount: this.SOInfo.CustAccount,
          DeliveryDate: _this.formatDate(_soline_current.ConfirmedDlv),
          TaxGroup: this.SOInfo.TaxGroup,
          SalesPoolId: this.SOInfo.SalesPoolId,
          InclTax: this.SOInfo.InclTax == "是" ? 1 : 0,
          TEC_Remark: this.SOInfo.TEC_Remark,
          TEC_FinalCustAccount: this.SOInfo.TEC_FinalCustAccount,
          LineNum: t.id,
          ItemId: _soline_current.ItemId,
          RetailVariantId: t.RetailVariantId,
          SalesPrice: _soline_current.SalesPrice,
          CurrencyCode: _soline_current.CurrencyCode,
          ConfirmedDlv: _this.formatDate(t.delivery_date),
          SalesUnit: _.isEmpty(_DW_InventUnitId) == true ? "个" : _DW_InventUnitId,
          SalesQty: t.qty,
          TEC_CommonRemark: _soline_current.TEC_CommonRemark,
          TEC_CustSalesID: _soline_current.TEC_CustSalesID,
          TEC_LineAmountBak: "",
          SEI_OrderDateCust: _this.formatDate(_soline_current.SEI_OrderDateCust),
          SEI_PriceUnitCust: _soline_current.SEI_PriceUnitCust,
          SEI_ShippingDateCust: _this.formatDate(_soline_current.SEI_ShippingDateCust),
          // "dataAreaId": "070",
          VendAccount: _AccountNum,
          VendTaxGroup: _vendTaxGroup,
          AXInventTransRet: _AXInventTransRet,
          AXPurchInventTransRet: _AXPurchInventTransRet,
          SalesNO: _soline_current.SalesId, ///订单编号
          CreateBy: _soline_current.create_by_username,
          PurchPrice: t.price,
          PurchCurrencyCode: _purch_code,
          PurchDeliveryDate: _this.formatDate(t.delivery_date),
          PurchUnit:
            _.isEmpty(_DW_InventUnitId) == true ? "个" : _DW_InventUnitId,
          Status: _Status,
          AXSalesId: t.AXSalesId,
          AXInventTransId: t.AXInventTransId,
          AXPurchId: t.AXPurchId,
          AXPurchInventTransId: t.AXPurchInventTransId,
          AXSalesLineNum: _.isNull(t.AXSalesLineNum) ? "" : t.AXSalesLineNum,
          AXPurchLineNum: _.isNull(t.AXPurchLineNum) ? "" : t.AXPurchLineNum,
          ApproveStatus: _ApproveStatus,
          InventLocationId: _soline_current.DW_inventBatchIdSales,
          DeliveryAddress: _soline_current.DeliveryAddress //订单明细送货地址
        })
      }
      console.log(_jsonData)
      let _group_data = _.groupBy(_jsonData, "VendAccount")
      return { company: this.SOInfo.dataAreaId, jsonGroupData: _group_data }
    },

    ///修改采购单相关信息
    getUpdatePurchaseOrderParams(items) {
      let _list = []
      _.each(items, (t) => {
        let _p = {
          OrderDispatch_id: t.id,
          PurchQty: t.qty, //数量
          PurchPrice: t.price,
          PurchUnit: _.isNull(this.invent_m)
            ? ""
            : this.invent_m.DW_InventUnitId,
          LineAmount: t.qty * t.price,
        }
        _list.push(_p)
      })
      return _list
    },

    ///删除采购单信息
    async delPurchaseOrder(items) {
      let _list = []
      _.each(items, (t) => {
        let _p = {
          OrderDispatch_id: t.id,
        }
        _list.push(_p)
      })
      console.log(_list)
      let _rel_save_data = await PurchaseOrderController.methods.delItemData(
        _list
      )
      if (!_.isNull(_rel_save_data)) {
        console.log("采购订单删除成功！")
      }
    },

    ///获取订单及物料相关信息
    async getInventData() {
      let _soLine_m = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()

      let _invent_info = await InventTableController.methods.getItemData({
        ItemId: _soLine_m.ItemId,
        dataAreaId: this.SOInfo.dataAreaId,
      })
      if (!_.isNull(_invent_info) && _invent_info && _invent_info.length > 0) {
        this.invent_m = _invent_info[0][0]
      }
    },

    ///审批邮件模板
    orderEmailTemplate(_selectedlist) {
      let _this = this
      let _params = {}
      let notify_list = []
      let order_line_m = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()

      let company_name = ""
      let _company_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { DataArea: order_line_m.dataAreaId })
      if (_company_m) {
        company_name = _company_m.CompanyName
      }
      _params.main = {
        type_name: "销售订单派发审批",
        url:
          window.location.protocol +
          "//" +
          window.location.host +
          "/sd/saleOrderDispatch?k=" + order_line_m.SalesId,
        url_name: window.location.host + "/sd/saleOrderDispatch?k=" + order_line_m.SalesId,
        order_code: order_line_m.SalesId,
        customer_name: order_line_m.SEI_Name,
        order_pool: order_line_m.SalesPoolId,
        invent_id: order_line_m.ItemId,
        invent_name: order_line_m.NameAlias,
        variant_name: order_line_m.VariantName,
        sales_price: order_line_m.SalesPrice,
        currency_code: order_line_m.CurrencyCode,
        exch_rate: order_line_m.ExchRate,
        sales_qty: order_line_m.SalesQty,
        tax_group: order_line_m.TaxGroup,
        delivery_date: this.formatDate(order_line_m.ConfirmedDlv),
        sales_company: company_name,
        sales_description: order_line_m.TEC_CommonRemark,
        username: this.$global.global_data.local_username,
        create_at: _this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
      }

      _.each(_selectedlist, async (t) => {
        let lang_code = notify_template.methods.getUserLangCode(this, t.Approver)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _notify_p = {
          category: "sod_approve",
          idx: t.id,
          itemId: t.id,
          notify_type: "sod_approve",
          subject: email_template["sod_approved_be_care"],
          content: "",
        }
        _params.email_user = t.Approver
        _params.items = []
        _params.items.push({
          vend_num: t.AccountNum,
          vend_name: t.SEI_Name,
          qty: t.qty,
          price: t.price,
          currency_code: t.PurchCurrencyCode,
          cost_price: t.Cost_Sum,
          price_rate: numbro((order_line_m.SalesPrice - t.price) / order_line_m.SalesPrice * 100).format({
            thousandSeparated: true,
            mantissa: 2,
          }),
          vend_price: t.price_vend,
          exch_rate: order_line_m.ExchRate,
          tax_group: order_line_m.TaxGroup,
          capacity: t.Capacity,
          invent_sum: t.invent_sum,
          total_score: t.TotalScore,
          delivery_date: this.formatDate(t.delivery_date),
          dispatch_date: this.formatDate(t.create_at)
        })

        let _index = _.findIndex(notify_list, { idx: t.id })
        if (_index < 0) {
          _notify_p.content = notify_template.methods.getSalesOrderTemplate(_params, this)
          notify_list.push(_notify_p)
        }
      })

      return notify_list
    },
    ///send email
    async SendEmail(data) {
      ///判断是否是自己创建的数据
      let is_my_data = true
      let _data = this.$refs.saleOrderDispatchSearchTable2.GetSelectedItems()
      if (data.data_sourse)
        _data = data.data_sourse

      if (!data.is_not_notify) {
        _.each(_data, (t) => {
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id
          ) {
            is_my_data = false
          }
        })
        if (!is_my_data) {
          this.msgToasts(this.$t("notify.not_created_by_yourself"))
          return
        }
      }

      let _this = this
      let _list = _.orderBy(_data, ["id"], ["desc"])
      if (_list.length > 0) {
        if (data.code == "add") {
          let is_go = true
          if (!data.is_not_notify) {
            await this.msgModal(this.$t("notify.is_send_email")).then((v) => {
              is_go = v
            })
          }
          if (is_go) {
            let notify_list = []
            //====审批
            let order_email_list = _list
            if (!data) {
              order_email_list = _.filter(_list, { fcCheckDocumentAllApproved: false })
            }
            if (order_email_list.length > 0) {
              ///发送邮件
              let content_list = [], exception_list = []
              let group_by_approver = _.groupBy(order_email_list, "Approver")
              for (var g in group_by_approver) {
                let _gt = group_by_approver[g]
                for (var d in _gt) {
                  let dm = _.cloneDeep(_gt[d])
                  dm.price_wotax == "" ? 0 : dm.price_wotax
                  dm.price_vend_wotax == "" ? 0 : dm.price_vend_wotax
                  let so_item_m = _.find(this.$refs.saleOrderDispatchSearchTable1.my_data, { id: dm.SalesLineId })
                  let content_list_m = {
                    UserName: dm.create_by_username,
                    SendDate: this.formatDate(dm.create_at, "yyyy-MM-dd HH:mm:ss"),
                    ItemId: dm.ItemId,
                    NameAlias: dm.NameAlias,
                    VendAccountName: dm.SEI_Name,
                    InitialVendPrice: _.round(dm.price_vend_wotax, 2),
                    VendPrice: _.round(dm.price_wotax, 2),
                    Sales_Order_Price: _.round(dm.Sales_Order_Price, 2),//实际销售价
                    ProfitRate: dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_wotax) * 100 / dm.Sales_Order_Price, 2), //(订单价格-实际采购价)/订单价格
                    InitialProfitRate: dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_vend_wotax) * 100 / dm.Sales_Order_Price, 2), //订单价格-初始报价）/订单价格
                    Qty: dm.qty, //派发数量
                    Amount: _.round(_.round(dm.price_wotax, 2) * dm.qty, 2), //派发金额
                    isAXError: dm.isAXError ? "异常" : "",
                    AXError: dm.AXError,
                    Remark: so_item_m ? so_item_m.TEC_CommonRemark : "", //通用备注
                    PriceRemark: dm.price_remark, //实际采购价备注
                  }
                  ///出现异常则不发邮件给供应商通知人以及派发创建人
                  if (dm.isAXError) {
                    exception_list.push(content_list_m)
                  }
                  else {
                    content_list.push(content_list_m)
                  }
                }
                if (g != "" && content_list.length > 0) {
                  let email_data = {
                    main: {
                      Title: "",
                      Url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch?k=" + _gt[0].SalesId,
                      Url_Name: window.location.host + "/sd/saleOrderDispatch?k=" + _gt[0].SalesId,
                      UserName: this.$global.global_data.local_username,
                      SendDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
                    },
                    list: content_list
                  }
                  let email_content = notify_template.methods.getTemplate(this, "vend_purch_price_change", email_data, g)

                  let lang_code = notify_template.methods.getUserLangCode(this, g)
                  let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

                  let _send_to = {}
                  _send_to[g] = ""
                  let _notify_p = {
                    category: "SalesOrderDispatch",
                    idx: "",
                    itemId: 0,
                    notify_type: "SalesOrderDispatch",
                    subject: _gt[0].SalesId + email_template["sod_wait_approve_be_care"],
                    content: email_content,
                    SendTo: _send_to
                  }
                  notify_list.push(_notify_p)
                }
              }
              ///如果出现异常则发邮件给异常处理人
              if (exception_list.length > 0) {
                let _profit_m = _.find(
                  this.$store.state.biz_data.baseData.SystemSetting,
                  { code: "email_notifier" }
                )
                if (_profit_m && _profit_m.setting_value != "") {
                  let m = JSON.parse(_profit_m.setting_value)
                  if (m.dispatchErrorEmailNotifier && m.dispatchErrorEmailNotifier.length > 0) {
                    let eusers = []
                    let roles = _.map(
                      this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
                      "code"
                    )
                    for (var i in m.dispatchErrorEmailNotifier) {
                      if (_.includes(roles, m.dispatchErrorEmailNotifier[i])) {
                        let _result = await RoleManageController.methods.GetRoleUsers(-1, m.dispatchErrorEmailNotifier[i])
                        _result = _.filter(_result, { is_sys: false })
                        if (_result && _result.length > 0) {
                          _.each(_result, (t) => {
                            eusers.push(t)
                          })
                        }
                      }
                      else {
                        eusers.push(m.dispatchErrorEmailNotifier[i])
                      }
                    }
                    eusers = _.uniq(eusers)//去除重复项
                    _.each(eusers, (tm) => {
                      let lang_code = notify_template.methods.getUserLangCode(this, tm)
                      let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

                      let email_data = {
                        main: {
                          Title: "",
                          Url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch",
                          Url_Name: window.location.host + "/sd/saleOrderDispatch",
                          UserName: this.$global.global_data.local_username,
                          SendDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
                        },
                        list: exception_list
                      }
                      let email_content = notify_template.methods.getTemplate(this, "vend_purch_price_change_exception", email_data, tm)

                      let _send_to = {}
                      _send_to[tm] = ""
                      let _notify_p = {
                        category: "SalesOrderDispatch",
                        idx: "",
                        itemId: 0,
                        notify_type: "SalesOrderDispatch",
                        subject: email_template["sod_ax_error_handing"],
                        content: email_content,
                        SendTo: _send_to
                      }
                      notify_list.push(_notify_p)
                    })
                  }
                }
              }
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  "add",
                  notify_list
                )
                if (!_.isNull(_rsult) && !data.is_not_notify) {
                  _this.msgToasts(this.$t("notify.email_seccess"), "success")
                }
              }
            } else if (_list.length > 0 && notify_list.length == 0 && !data.is_not_notify) {
              _this.msgToasts(this.$t("notify.approved_can_not_send_email"), "info")
            }

            // let order_email_list = _.filter(_list, { fcCheckDocumentAllApproved: false })
            // let _order_email_temp_list = this.orderEmailTemplate(order_email_list);
            // if (_order_email_temp_list.length > 0) {
            //   notify_list = _.union(notify_list, _order_email_temp_list);
            // }

            // if (notify_list.length > 0) {
            //   let _rsult = await commonController.methods.sendOrCancelNotify(
            //     data.code,
            //     notify_list
            //   );
            //   if (!_.isNull(_rsult)) {
            //     _this.msgToasts(this.$t("notify.email_seccess"), "success");
            //     await commonController.methods.updateEmailSendState(
            //       "sod",
            //       _list
            //     );
            //     _.each(_list, (t) => {
            //       t.is_email_send = true
            //     });
            //   }
            // } else if (_list.length > 0 && notify_list.length == 0) {
            //   _this.msgToasts(this.$t("notify.approved_can_not_send_email"), "info");
            // }
          }
        } else {
          this.msgModal(this.$t("notify.is_repeal_email")).then(async (v) => {
            if (v) {
              let notify_list = []
              _.each(_list, (t) => {
                ///普通审批邮件
                notify_list.push({
                  idx: t.id,
                  notify_type: "sod_approve",
                })
              })
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  data.code,
                  notify_list
                )
                if (!_.isNull(_rsult)) {
                  _this.msgToasts(this.$t("notify.approved_email_cancel_success"), "success")
                }
              }
            }
          })
        }
      } else if (!data.is_not_notify) {
        this.msgToasts(this.$t("notify.not_data"), "info")
      }
    },

    ///获取或设置派单相关信息
    async setDisDataStateAndInfo(table_ref, woFields, current_item) {
      let _p = {
        get_pc: [],
        check_vend_has_invent: [],
        amount_tax: [],
      }
      ///设置价格
      if (current_item) {
        await this.setItemPrice(current_item, table_ref, woFields)
      } else {
        for (var i in this.$refs[table_ref].my_data) {
          let t = this.$refs[table_ref].my_data[i]
          await this.setItemPrice(t, table_ref, woFields)
        }
      }

      ///获取产能
      _.each(this.$refs[table_ref].my_data, (t) => {
        if (current_item) {
          if (t.id == current_item.id) {
            _p.get_pc.push({
              AccountNum: t.AccountNum,
              delivery_date: t.delivery_date,
              _id: t.id,
            })
          }
        } else {
          _p.get_pc.push({
            AccountNum: t.AccountNum,
            delivery_date: t.delivery_date,
            _id: t.id,
          })
        }
      })

      ///获取不含税价格
      // _.each(this.$refs[table_ref].my_data, (t) => {
      //   let current = this.SOInfo;
      //   let _amount_tax = {
      //     currency: t.PurchCurrencyCode,
      //     amount: t.price,
      //     incTax: 0,
      //     taxGroup: "",
      //     dataAreaId: current.dataAreaId,
      //     _id: t.id,
      //   };
      //   let vender = _.find(this.$store.state.biz_data.baseData.Vender, {
      //     AccountNum: t.AccountNum,
      //   });
      //   if (vender) {
      //     _amount_tax.incTax = vender.InclTax == "是" ? 1 : 0;
      //     _amount_tax.taxGroup = vender.TaxGroup;
      //   }
      //   if (current_item) {
      //     if (t.id == current_item.id) {
      //       _p.amount_tax.push(_amount_tax);
      //     }
      //   } else {
      //     _p.amount_tax.push(_amount_tax);
      //   }
      // });
      let _table3_list = this.$refs[table_ref].my_data
      // console.log(_table3_list)
      let _result = await saleOrderDispatchAddController.methods.getDisDataStateAndInfo(_p)
      if (!_.isNull(_result) && _result) {
        ///设置产能
        let _filter_pc = _.filter(_result, { Code: "data/e/get_vend_production_capacity", })
        _.each(_filter_pc, (t) => {
          if (!_.isNull(t.Result) && t.Result) {
            if (t.Result.Data && !_.isNull(t.Result.Data)) {
              for (var i in t.Result.Data) {
                let _id = t.Params[i]._id
                if (current_item) {
                  _id = current_item.id
                }
                // let _m = _.cloneDeep(_.find(_table3_list, { id: _id }));
                let _m = {}
                _m.Capacity = t.Result.Data[i][0].ProductionCapacity
                this.$refs[table_ref].UpdateItemsWOField(
                  { id: _id },
                  _m,
                  woFields
                )
              }
            }
          }
        })

        ///设置净价
        // let _filter_amt = _.filter(_result, {
        //   Code: "data/e/get_LocalAmountWOTax",
        // });

        // _.each(_filter_amt, (t) => {
        //   if (!_.isNull(t.Result) && t.Result) {
        //     for (var i in t.Result.Data) {
        //       let _id = t.Params[i]._id;
        //       if (current_item) {
        //         current_item.price_tax = 0;
        //         current_item.price_wotax = 0;
        //         _id = current_item.id;
        //       }
        //       // let _m = _.cloneDeep(_.find(_table3_list, { id: _id }));
        //       let _m = {};
        //       if (_m && t.Result.Data && !_.isNull(t.Result.Data)) {
        //         if (!_.isNull(t.Result.Data[i][0].CNYAmount)) {
        //           _m.price_tax = _.round(t.Result.Data[i][0].CNYAmount, 6);
        //         }

        //         if (!_.isNull(t.Result.Data[i][0].CNYAmountWOTax)) {
        //           _m.price_wotax = _.round(
        //             t.Result.Data[i][0].CNYAmountWOTax,
        //             6
        //           );
        //         }
        //       }
        //       this.$refs[table_ref].UpdateItemsWOField(
        //         { id: _id },
        //         _m,
        //         woFields
        //       );
        //     }
        //   }
        // });
      }
    },
    async getItemPrice(ItemIds) {
      let _this = this
      let _result = await VendPurchaseQuoteOutController.methods.getSimpleData({
        ItemId: { in: ItemIds },
        is_approved: { "=": 1 },
        is_deleted: { "=": 0 },
      })
      this.his_group_price_list = null
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _price_list = _.orderBy(
          _result[0].Result.Data[0],
          ["AccountNum", "QuantityAmountFrom"],
          ["asc", "desc"]
        )

        ///初始化对比数据
        _.each(_price_list, (t) => {
          if (!_.isNull(t.FromDate)) {
            t.FromDate = _this.$date.format(new Date(t.FromDate), "yyyy-MM-dd")
          } else {
            t.FromDate = "1900-01-01"
          }

          if (!_.isNull(t.ToDate)) {
            t.ToDate = _this.$date.format(new Date(t.ToDate), "yyyy-MM-dd")
          } else {
            t.ToDate = "2099-12-31"
          }

          if (t.QuantityAmountFrom == 0 || _.isNull(t.QuantityAmountFrom)) {
            t.QuantityAmountFrom = 0
          }

          if (t.QuantityAmountTo == 0 || _.isNull(t.QuantityAmountTo)) {
            t.QuantityAmountTo = Number.MAX_VALUE
          }
          t.section = t.QuantityAmountTo - t.QuantityAmountFrom
        })
        let _group_price_list = _.groupBy(_price_list, "AccountNum")
        this.his_group_price_list = _group_price_list
      }
    },
    async getRelatedPrice(item) {
      let plist = []
      let so_m = this.$refs.saleOrderDispatchSearchTable1.GetCurrentItem()
      plist.push({
        itemId: item.ItemId,
        currency: item.CurrencyCode ? item.CurrencyCode : item.PurchCurrencyCode,
        dataAreaId: so_m.dataAreaId,
        accountNum: so_m.CustAccount,
        vendAccountNum: item.AccountNum == "" ? null : item.AccountNum,
        qty: item.qty
      })
      // _.each(list, (item) => {
      //   plist.push({
      //     itemId: item.ItemId,
      //     currency: item.CurrencyCode ? item.CurrencyCode : item.PurchCurrencyCode,
      //     dataAreaId: so_m.dataAreaId,
      //     accountNum: so_m.CustAccount,
      //     vendAccountNum: item.AccountNum == "" ? null : item.AccountNum,
      //     qty: item.qty
      //   })
      // })

      let result = await VendPurchaseQuoteOutController.methods.getPriceRelated(plist)
      if (result && result.length > 0 && result[0] && result[0].Result && result[0].Result.Data
        && result[0].Result.Data.length > 0 && result[0].Result.Data[0]) {
        let pm_list = result[0].Result.Data
        let pm = pm_list[0][0]
        console.log(pm)
        item.Initial_Vend_Price = pm.initial_vend_price//初始报价
        item.Initial_Vend_Price_WOTax = pm.initial_vend_price_wotax//初始报价本币净单价
        item.Vend_Price = pm.vend_price//供应商报价确认
        item.Vend_Price_WOTax = pm.vend_price_wotax//供应商报价确认本币净单价
        item.Sales_Doc_Price = pm.salesPrice//协议价格
        item.Sales_Cost = pm.salesCost//成本
        item.Vend_Cost = pm.vend_cost//供应商成本
        item.Vend_Price_Currency = pm.vend_price_currency//供应商报价确认币种
        item.Initial_Vend_Price_Currency = pm.initial_vend_price_currency//供应商初始报价币种
        item.price_remark = pm.price_remark//实际采购价备注
        // for (var i in pm_list) {
        //   let pm = pm_list[i][0]
        //   console.log(pm)
        //   list[i].Initial_Vend_Price = pm.initial_vend_price;//初始报价
        //   list[i].Initial_Vend_Price_WOTax = pm.initial_vend_price_wotax;//初始报价本币净单价
        //   list[i].Vend_Price = pm.vend_price;//供应商报价确认
        //   list[i].Vend_Price_WOTax = pm.vend_price_wotax;//供应商报价确认本币净单价
        //   list[i].Sales_Doc_Price = pm.salesPrice;//协议价格
        //   list[i].Sales_Cost = pm.salesCost;//成本
        //   list[i].Vend_Cost = pm.vend_cost;//供应商成本
        //   list[i].Vend_Price_Currency = pm.vend_price_currency;//供应商报价确认币种
        //   list[i].Initial_Vend_Price_Currency = pm.initial_vend_price_currency;//供应商初始报价币种
        // }
      }
    },
    async setItemPrice(mt, table_ref, woFields) {
      //初始化报价和成本

      ///毛利区间
      let _profit_value = null
      let _profit_m = _.find(
        this.$store.state.biz_data.baseData.SystemSetting,
        { code: "profit_setting" }
      )
      if (_profit_m && _profit_m.setting_value != "") {
        _profit_value = JSON.parse(_profit_m.setting_value)
      }

      // mt.price = 0;
      // mt.Cost_Sum = 0;
      //mt.PurchCurrencyCode = "CNY";
      await this.getRelatedPrice(mt)
      console.log(mt)
      // ///外部供应商才判定是否取初始报价
      // let _company = _.find(
      //   this.$store.state.biz_data.baseData.CompanyInfo,
      //   { VenderAccountNum: mt.AccountNum }
      // );

      // if (_company) {
      //   //内部供应商
      //   mt.price = mt.Vend_Price;
      // }
      // else {
      //   mt.price = mt.Vend_Price == -1 ? mt.Initial_Vend_Price : mt.Vend_Price;
      // }
      mt.price = mt.Vend_Price
      mt.price_wotax = mt.Vend_Price_WOTax//供应商报价确认本币净单价
      mt.price_vend = mt.Initial_Vend_Price//初始报价
      mt.price_vend_wotax = mt.Initial_Vend_Price_WOTax//初始报价本币净单价
      mt.quote_state = 2
      mt.Cost_Sum = mt.Vend_Cost == -1 ? "" : mt.Vend_Cost
      //如果为空则显示为空
      mt.price = mt.price == -1 ? "" : mt.price
      mt.price_wotax = mt.price_wotax == -1 ? "" : mt.price_wotax
      mt.price_vend = mt.price_vend == -1 ? "" : mt.price_vend
      mt.price_vend_wotax = mt.price_vend_wotax == -1 ? "" : mt.price_vend_wotax

      if (mt.price != mt.price_vend) {
        mt.quote_state = 0
      } else {
        mt.quote_state = 2
      }

      //不是本币时要转换为本币
      let _sales_price = mt.Sales_Order_Price
      // let _so_current = this.SOInfo;
      // if (_so_current && _so_current.CurrencyCode != "CNY") {
      //   _sales_price = parseFloat(mt.Sales_Order_Price) * parseFloat(_so_current.ExchRate);
      // }

      //不是本币时要转换为本币
      let _temp_price = mt.price_wotax
      // if (_so_current && mt.PurchCurrencyCode != "CNY") {
      //   _temp_price = parseFloat(mt.price) * parseFloat(_so_current.ExchRate);
      // }

      let _profit = ((parseFloat(_sales_price) - parseFloat(_temp_price)) / parseFloat(_sales_price)) * 100
      // console.log(_line_current.SalesPrice, _temp_price, _profit)
      mt.profit_value = _.round((parseFloat(_sales_price) - parseFloat(_temp_price)), 6)
      mt.profit_state = 2
      if (!_.isNull(_profit_value)) {
        if (_profit < parseFloat(_profit_value.minProfit)) {
          mt.profit_state = 0
        } else if (_profit < parseFloat(_profit_value.maxProfit)) {
          mt.profit_state = 1
        } else if (_profit >= parseFloat(_profit_value.maxProfit)) {
          mt.profit_state = 2
        }
      }
      this.$refs[table_ref].UpdateItemsWOField({ id: mt.id }, mt, woFields)
    },
    ///刷新价格
    async RefreshVendPrice(is_notify) {
      let unapprove_data = _.filter(this.$refs.saleOrderDispatchSearchTable2.my_data, { fcCheckDocumentAllApproved: false })
      for (var i in unapprove_data) {
        await this.setDisDataStateAndInfo("saleOrderDispatchSearchTable2", ["Capacity", "delivery_date"], unapprove_data[i])
      }
      if (is_notify) {
        this.msgToasts(this.$t("notify.vend_price_refresh_success"), "success")
      }
    },

    ///检查是否包含该审批权限
    async checkApproveStatus(approve_state) {
      let _check_list = []
      let _roles = []

      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let _selected_list = this.$refs.saleOrderDispatchSearchTable2.GetSelectedItems()
      for (var i in _selected_list) {
        let t = _selected_list[i]
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesOrderDispatch",
          ApproveType: "",
          ItemId: t.id,
        })
        let _is_ok = true
        let is_check_approved_state = approve_state ? false : true//approve_state==true 审批
        let at_list = _.filter(_as_result[0], { isApproved: is_check_approved_state })
        for (var j in at_list) {
          let at = at_list[j]
          if (at) {
            let _approver = t.Approver
            ///如果是反审则需要判定上一级审批人
            if (is_check_approved_state && t.Up_Approver) {
              _approver = t.Up_Approver
            }
            let _role = ""
            if (t.fcGetDocumentApprover) {
              _role = t.fcGetDocumentApprover.split(",")[0]
            }
            if (_.includes(_roles, _role) || this.$global.global_data.local_username == _approver) {
              _is_ok = false
            }
          }
        }
        ///指定角色反审判断
        let has_unapprove = _.includes(_roles, "SYS-Dispatch")

        if (!approve_state && has_unapprove) {
        }
        else {
          if (_is_ok && !_.includes(_check_list, t.id)) {
            _check_list.push(t.id)
          }
        }
      }
      return _check_list
    },

    // #region 异常处理
    ///异常筛选
    exception_changed() {
      if (this.only_ax_exception) {
        let list = _.filter(this.his_dispatch_list, { isAXError: this.only_ax_exception })
        this.$refs.saleOrderDispatchSearchTable2.SetData(list)
      }
      else {
        this.$refs.saleOrderDispatchSearchTable2.SetData(this.his_dispatch_list)
      }
    },
    ///异常处理
    async exception_handle(data, cb, _line_current) {
      let res_msg = []
      let dt = _.cloneDeep(data)
      dt.state = true
      let ft = _.filter(data.selected_items, { isAXError: true })
      if (ft.length == 0) {
        this.msgToasts(this.$t("notify.selected_not_exception"), "info")
        cb(false)
        return
      }
      ///权限判定（根据派发异常处理邮件通知判定）
      let _profit_m = _.find(
        this.$store.state.biz_data.baseData.SystemSetting,
        { code: "email_notifier" }
      )
      let roles = _.map(
        this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
        "code"
      )
      if (_profit_m && _profit_m.setting_value != "") {
        let m = JSON.parse(_profit_m.setting_value)
        if (m.dispatchErrorHandler) {
          let is_ok = false
          if (_.includes(m.dispatchErrorHandler, this.$global.global_data.local_username)) {
            is_ok = true
          }

          let intersection = _.intersection(roles, m.dispatchErrorHandler)
          if (intersection && intersection.length > 0) {
            is_ok = true
          }

          if (!is_ok) {
            this.msgToasts(this.$t("notify.not_privileges"), "info")
            cb(false)
            return
          }
        }
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.waiting"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let exception_vends = [], res_venders_msg_list = []
      let groupList = _.groupBy(ft, "AccountNum")
      for (var i in groupList) {
        let update_sod_list = _.map(groupList[i], (t) => {
          return {
            id: t.id,
            isAXError: false,
            // AXError: ""
          }
        })
        ///整理ax参数
        let ax_params = this.getAXParams(groupList[i], "error")
        let _params = {
          update_sod_data: update_sod_list,
          ax_data: ax_params
        }
        let result = await SaleOrderDispatchSearchController.methods.handleAxException(_params)
        if (!_.isNull(result)) {
          if (!result.state) {
            let _venders = _.map(groupList[i], "AccountNum")
            exception_vends.push(_venders[0])
            res_msg.push("<hr/><div>" + this.$t("common.provider") + this.$t("common.num") + "：" + _venders[0] + "，" + result.message + "</div>")
            res_venders_msg_list.push({
              vender: _venders[0],
              msg: result.message
            })
          }
        }
      }
      if (res_msg.length == 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.ax_error") + "：" + _.join(res_msg, " "), "info", null, true)
        cb(false)
        let _params = []
        _.each(data.selected_items, (t) => {
          if (_.includes(exception_vends, t.AccountNum)) {
            let m = _.find(res_venders_msg_list, { vender: t.AccountNum })
            if (m) {
              _params.push({
                isAXError: true,
                AXError: m.msg,
                id: t.id
              })
            }
          }
        })
        if (_params.length > 0) {
          await saleOrderDispatchAddController.methods.updateSODAxState(_params)
        }
      }
      loading.close()
      await this.getDispatchItems(_line_current)
    },
    // #endregion

    //#region 打印导出
    // tool_invoke(data, cb) {

    // },
    //#endregion
    //#region 附件
    async on_cell_button_click(data) {
      this.current_accessory = data.item
      if (data.field.key == "Accessory") {
        this.accessoryVisible = true
      }
    },
    dialogOpened() {
      this.$refs.refAccessory.getAccessory(this.current_accessory.Accessory, this.current_accessory.SalesLineId)
    },
    async dialogClosed() {
      if (this.current_accessory && this.current_accessory.Accessory) {
        let m = { id: this.current_accessory.id, Accessory: this.current_accessory.Accessory }, ml = []
        if (m.id && m.id != "") ml.push(m)
        this.current_accessory.AccessoryCount = JSON.parse(this.current_accessory.Accessory).length
        await SaleOrderDispatchSearchController.methods.updateDispatchAccessory({ edit: ml })
      }
    },
    async setAccessory(data) {
      this.current_accessory.Accessory = data
      await this.dialogClosed()
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_sods_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 185rem;
}

.hb_table_sods_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 300rem;
}
</style>
